import {Component, Input, OnInit} from "@angular/core";
import { Customer } from "../dto/customer";
import {AddressStatus, IdentLevel, IdentStatus} from "../dto/ident-status";
import {PepStatus} from "../dto/pep-status";

@Component({
  selector: 'app-customer-badges',
  templateUrl: './customer-badges.component.html',
  styleUrls: ['./customer-badges.component.css']
})
export class CustomerBadgesComponent implements OnInit {
  @Input() customer!: Customer;
  @Input() hideVulnerable: boolean = false;
  @Input() hideRisk: boolean = false;
  @Input() hideSof: boolean = false;
  @Input() compact: boolean = false;

  identLevel = IdentLevel;
  identStatus = IdentStatus;
  pepStatus = PepStatus;
  addressStatus = AddressStatus;



  constructor() { }

  ngOnInit(): void {

  }

}
